import $store from '@/store'
import { getObjectByCache, operateBranchIsOptional } from '@/utils/basicDataCache'
import { basicCacheKeys } from '@/utils/cacheConfig'
import { useOrderCenterMode } from '@/class/cargo/model/utils/RateUtil'

/**
 * 对账列表费用标识：业务编号+费用名称+币种+金额
 */
export function formatReconciliationChargeLabel(row) {
  if (!row) {
    return ''
  }
  const jobNo = row.jobJobNo || ''
  const chargeItem = getObjectByCache(basicCacheKeys.basic_data_ChargeItem, 'itemId', Number(row.chargeChargeItemId))
  const chargeItemName = chargeItem ? (chargeItem.zhName || chargeItem.enName || '') : ''
  const currency = row.chargeCurrency || ''
  const amount = row.chargeAmount != null ? row.chargeAmount : ''
  if (jobNo || chargeItemName) {
    return `${jobNo}+${chargeItemName}+${currency}+${amount}`
  }
  return row.uuid || ''
}

/**
 * 对账列表行 -> 费用校验对象
 */
export function normalizeReconciliationCharge(row) {
  if (!row) {
    return null
  }
  return {
    uuid: row.uuid,
    receivable: row.chargeReceivable === true || row.chargeReceivable === 1 || row.chargeReceivable === '1',
    verifiedAmount: Number(row.chargeVerifiedAmount || 0),
    billingUuid: row.billingUuid,
    invoiceUuid: row.invoiceUuid,
    billingPaymentUuid: row.billPaymentUuid || row.billingPaymentUuid,
    chargeState: row.chargeChargeState,
    confirmState: row.chargeConfirmState,
    accountId: row.chargeAccountId,
    invoiceTitle: row.chargeInvoiceTitle,
    branchId: row.chargeBranchId,
    createdBy: Number(row.chargeCreatedBy || 0),
    inputBy: Number(row.chargeInputBy || 0),
    shared: row.chargeShared || row.shared,
    collection: row.chargeCollection || row.collection,
    shareScheme: row.chargeShareScheme || row.shareScheme || 0,
    agentSharedBillingUuid: row.agentSharedBillingUuid,
    confirmBillUuid: row.confirmBillUuid,
    diffChargeUuid: row.diffChargeUuid
  }
}

function checkDepartmentTeam(charge, departmentTeamUser = []) {
  const userId = $store.getters.userId
  if (!charge.createdBy || charge.createdBy === 0 || charge.inputBy === userId || charge.createdBy === userId) {
    return true
  }
  for (const teamUserId of departmentTeamUser) {
    if (teamUserId === charge.inputBy || teamUserId === charge.createdBy) {
      return true
    }
  }
  return false
}

export function checkRoleEdit(charge, privilege, departmentTeamUser = []) {
  if (!charge) {
    return false
  }
  const userId = $store.getters.userId
  if (charge.createdBy === 0 || charge.inputBy === userId || charge.createdBy === userId) {
    return true
  }
  if (charge.receivable) {
    if (privilege.editArAllCharge) {
      return true
    }
    if (privilege.editArDeptCharge && checkDepartmentTeam(charge, departmentTeamUser)) {
      return true
    }
  } else if (privilege.editApAllCharge) {
    return true
  } else if (privilege.editApDeptCharge && checkDepartmentTeam(charge, departmentTeamUser)) {
    return true
  }
  return false
}

export function checkEditPersonalArCharge(charge, privilege) {
  if (!charge) {
    return false
  }
  return true
}

export function checkEditPersonalApCharge(charge, privilege) {
  if (!charge) {
    return false
  }
  return true
}

/**
 * 费用业务状态是否可编辑（对齐 tabChargesHP.shareEnable 核心条件）
 */
export function isReconciliationChargeShareEnabled(charge) {
  if (!charge) {
    return false
  }
  if (charge.verifiedAmount !== 0 || charge.billingUuid || charge.billingPaymentUuid || charge.invoiceUuid ||
    charge.shared || charge.collection || charge.agentSharedBillingUuid || charge.confirmBillUuid ||
    charge.diffChargeUuid || (charge.chargeState !== 0 && charge.chargeState !== 3 && charge.chargeState !== undefined && charge.chargeState !== null) ||
    charge.confirmState === 1 || charge.shareScheme > 0) {
    return false
  }
  return true
}

export function isReconciliationChargeEditable(row, privilege, departmentTeamUser = []) {
  const charge = normalizeReconciliationCharge(row)
  if (!charge) {
    return false
  }
  if (!isReconciliationChargeShareEnabled(charge)) {
    return false
  }
  if (!checkRoleEdit(charge, privilege, departmentTeamUser)) {
    return false
  }
  if (charge.receivable) {
    if (!checkEditPersonalArCharge(charge, privilege)) {
      return false
    }
  } else if (!checkEditPersonalApCharge(charge, privilege)) {
    return false
  }
  return true
}

export function buildChargeEditPrivilege(vm) {
  const useOrderCenter = useOrderCenterMode()
  return {
    editArAllCharge: vm.$checkPermission(['role_Charge_editArAllCharge']),
    editArDeptCharge: vm.$checkPermission(['role_Charge_editArDeptCharge']),
    editPersonalArCharge: vm.$checkPermission(['role_Charge_editPersonalArCharge']),
    editApAllCharge: vm.$checkPermission(['role_Charge_editApAllCharge']),
    editApDeptCharge: vm.$checkPermission(['role_Charge_editApDeptCharge']),
    editPersonalApCharge: vm.$checkPermission(['role_Charge_editPersonalApCharge']),
    modifyOtherBranchCharge: operateBranchIsOptional() ? false : (useOrderCenter && vm.$checkPermission(['button_Charge_modifyOtherBranchCharge']))
  }
}
